<template>
  <div>

    <vs-tabs alignment="fixed">
      <vs-tab label="Detalles documento">
        <div class="tab-text">
          <div>
            <vs-card v-if="!popupAddSignatures">
              <div class="p-1">
                <div slot="header">
                  <h4 class="pb-2 text-primary">Detalles:</h4>
                </div>
                <div>
                  <h6>Nombre del documento: </h6>
                  <p class="pb-2">{{ document.attributes.file_name }}</p>
                  <h6>Hash: </h6>
                  <p class="brakeall font-13 pb-2">{{ document.attributes.original_hash.toLowerCase() }}</p>
                  <h6>Estrategia de firmado: </h6>
                  <p class="brakeall font-13 pb-2">{{ sign_strategies[document.attributes.signature_mode] }}</p>
                  <div v-if="document.attributes.createdBy">
                    <h6>Creado por: </h6>
                    <p class="brakeall font-13">{{ document.attributes.createdBy }}</p>
                  </div>
                </div>
              </div>
            </vs-card>
            <vs-card class="mb-0">
              <div>
                <vs-list>
                  <vs-list-header title="Firmantes" class="pt-0" color="primary"></vs-list-header>
                  <vs-list-item class="list-item" v-for="listItem in document.relationships.signatories.data" :key="listItem.attributes.email" :title="listItem.attributes.name" :subtitle="listItem.attributes.email">
                    <vs-avatar slot="avatar" :text="listItem.attributes.name.split(' ').slice(0,2).join(' ').trim()" />

                    <vx-tooltip v-if="listItem.attributes.sign_status==='PENDING'" text="Cambiar email" position="top" class="d-inline-block">
                      <feather-icon icon="SendIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="emailUpdatePrompt=true;signatureToUpdate=listItem" />
                    </vx-tooltip>

                    <vx-tooltip v-if="listItem.attributes.sign_status==='PENDING'" text="Copiar enlace de firma" position="top" class="d-inline-block">
                      <feather-icon icon="ClipboardIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="copySignatureLink(listItem)" />
                    </vx-tooltip>

                    <vx-tooltip v-if="signaturesFlows.find(item => item.signature_id === listItem.id).attributes.signature_flow_id" text="Mostrar detalle del flujo de firmado" position="top" class="d-inline-block">
                      <feather-icon icon="EyeIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 cursor-pointer" @click="signatureDetailPrompt=true;signatureToUpdate=listItem" />
                    </vx-tooltip>

                    <p class="float-right">{{ sign_status[listItem.attributes.sign_status] }}</p>
                  </vs-list-item>
                </vs-list>
                <vs-button v-if="isAvailableToAddSignatures" class="mt-2" @click="popupAddSignatures = true">Añadir firmantes</vs-button>
              </div>
            </vs-card>

            <vs-card v-if="document.attributes.sign_status === 4" class="mb-0">
              <div slot="header">
                <h4 class="pb-2 text-primary">Motivo de rechazo:</h4>
              </div>
              <div v-html="document.attributes.rejected_message ? document.attributes.rejected_message : 'El firmante no dejo un motivo'">
              </div>
            </vs-card>

            <vs-card class="p-2 mt-5 mb-0 sign" v-if="popupAddSignatures">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <h4 class="pb-2 text-primary">Añadir firmantes</h4>
                  <p>Añade a las personas que deberán firmar los documentos</p>
                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2">
                  <vs-input class="w-full" label-placeholder="Nombre" v-model="name" />
                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2">
                  <vs-input class="w-full" label-placeholder="Correo" v-model="email" />
                </div>
                <div class="vx-col w-full mb-2">
                  <vs-input class="w-full" label-placeholder="Restringir con RFC o CURP (opcional)" v-model="rfc" />
                  <vs-button class="mt-3" type="border" @click="addSignature">Añadir firmante</vs-button>
                </div>

                <div class="vx-col w-full">
                  <vs-list v-if="signatures.length">
                    <vs-list-header title="Firmantes añadidos" color="secondary"></vs-list-header>
                    <p v-if="!signatures.length">No hay firmantes aún, prueba añadiendo uno con el formulario.</p>
                    <vs-list-item v-if="signatures.length" class="list-item" v-for="listItem in signatures" :key="listItem.email" :title="listItem.name" :subtitle="listItem.email">
                      <vs-avatar slot="avatar" :text="listItem.name.split(' ').slice(0,2).join(' ').trim()" />
                    </vs-list-item>
                  </vs-list>
                  <p>Cuando termines de añadir todos los firmantes finaliza aquí</p>
                  <vs-button class="mt-2" @click="updateDocument">Actualizar documento</vs-button>
                  <vs-button @click="popupAddSignatures = false" class="float-right mt-2" type="border">Cancelar</vs-button>
                </div>
              </div>
            </vs-card>
          </div>
          <vs-button type="border" @click="companiesPopUp = true">Mover</vs-button>
        </div>
      </vs-tab>

      <vs-tab label="Vista previa documento">
        <div class="tab-text mb-0">
          <vs-card class="mb-0">
            <div slot="header">
              <h4 class="pt-2 text-primary bold">Vista previa</h4>
            </div>
            <div class="mb-0">
              <ReactPdfViewer class="embed-h background-fb card-p" v-if="isShowPdf" :pdf="api_url + '/documents/' + document.id + '/download_original'" height="100%"></ReactPdfViewer>
            </div>
          </vs-card>
        </div>
      </vs-tab>

    </vs-tabs>

    <vs-prompt
    @cancel="emailToUpdate=''"
    @accept="changeEmail"
    title="Cambio de correo electrónico"
    accept-text="Aceptar"
    cancel-text="Cancelar"
    :active.sync="emailUpdatePrompt"
    >
      <vs-input class="center-element" placeholder="Ingresa un correo electrónico" v-model="emailToUpdate" />
    </vs-prompt>

    <vs-prompt
      @accept="moveDocument"
      @cancel="selectedCompanyToMove=null"
      title="Mover documento a una nueva carpeta de trabajo"
      accept-text="Aceptar"
      cancel-text="Cancelar"
      :is-valid="isDialogMoveDocumentValid"
      :active.sync="companiesPopUp"
    >
      <v-select placeholder="Selecciona una carpeta de trabajo" v-model="selectedCompanyToMove" :options="owned_companies" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
    </vs-prompt>

    <vs-prompt
      @cancel="signatureDetailPrompt = false"
      @accept="signatureDetailPrompt = false"
      title="Detalles del flujo de firmado"
      :buttons-hidden="true"
      :active.sync="signatureDetailPrompt"
    >
      <p><strong>Número de intentos realizados: </strong>{{ getSignatureFlow ? getSignatureFlow.attributes.signature_flow_try : '' }}</p>
      <br>
      <p><strong>Estatus del flujo de firmado: </strong>{{ getSignatureFlow ? getSignatureFlow.attributes.signature_flow_status : '' }}</p>
      <br>
      <p v-if="getSignatureFlow ? getSignatureFlow.attributes.signature_flow_error_message : false"><strong>Mensaje de error de la última verificación: </strong>{{ getSignatureFlow ? getSignatureFlow.attributes.signature_flow_error_message : '' }}</p>
      <vs-card class="mt-2" v-if="getSignatureFlow ? getSignatureFlow.attributes.signature_flow_try >= 3 : false">
        <small>Cuando los intentos permitidos exceden, es posible reiniciar el contador <strong>por el costo de una firma adicional</strong> (cada vez que se reinicia se consume una firma)</small><br>
        <vs-button style="margin: 0 auto; display: block!important;" type="border" @click="resetSignatureFlowTries">Reiniciar intentos</vs-button>
      </vs-card>
    </vs-prompt>

  </div>
</template>

<script>
import router from "@/router";
import {ReactInVue} from 'vuera';
import ReactPdfViewer from "../../../../components/viewer-pdf/ReactPdfViewer";
import {API_URL, SIGN_STRATEGIES, SIGN_STATUS} from "../../../../config/app";
import {mapState} from "vuex";
import vSelect from 'vue-select'

export default {
  name: "DetailDocument",
  props: ['uuid', 'closePopup'],
  components: {
    'ReactPdfViewer': ReactInVue(ReactPdfViewer),
    'v-select': vSelect
  },
  data() {
    return {
      companiesPopUp: false,
      popupAddSignatures: false,
      document: null,
      api_url: API_URL,
      isShowPdf: true,
      signatures: [],
      signaturesFlows: [],
      name: '',
      email: '',
      rfc: '',
      sign_strategies: SIGN_STRATEGIES,
      sign_status: SIGN_STATUS,
      emailToUpdate: '',
      emailUpdatePrompt: false,
      signatureToUpdate: null,
      selectedCompanyToMove: null,
      signatureDetailPrompt: false
    }
  },
  watch: {
    uuid(val) {
      if (val) {
        this.isShowPdf = false;
        this.$store.dispatch("document/getDocument", {uuid: val})
          .then(document => {
            this.document = document;
            this.isShowPdf = true;
            this.popupAddSignatures = false;
            this.signatures = [];
            this.name = '';
            this.email = '';
            this.rfc = '';
          })
      } else {
        router.push("/");
      }
    }
  },
  computed: {
    ...mapState({
      owned_companies: function (state) {
        return state.account.user.me.owned_companies;
      },
    }),
    isDialogMoveDocumentValid() {
      return this.selectedCompanyToMove;
    },
    isAvailableToAddSignatures() {
      return (this.document.attributes.sign_status === 1) && this.document.attributes.signature_ordered === "INACTIVE";
    },
    getSignatureFlow() {
      if (this.signatureToUpdate) {
        let found = this.signaturesFlows.find(item => item.signature_id === this.signatureToUpdate.id)
        console.log(found)
        if (found) {
          return found
        }
      }
    }
  },
  async created() {
    let instance = this;
    if (this.uuid) {
      this.$store.dispatch("document/getDocument", {uuid: this.uuid})
        .then(document => {
          this.document = document;
          document.relationships.signatories.data.forEach(async item => {
            let result = await this.$store.dispatch("document/getDocumentFromSignature", {uuid: item.id})
            if (result) {
              result.signature_id = item.id;
              instance.signaturesFlows.push(result)
              console.log(instance.signaturesFlows)
            }
          })
        })
    } else {
      router.push("/");
    }
  },
  methods: {
    moveDocument() {
      this.$store.dispatch("document/updateDocument", { document: { uuid: this.document.id }, company_id: this.selectedCompanyToMove.id }).then(
        () => {
          setTimeout(() => {
            location.reload(true);
          }, 500)
        }
      )
    },
    copySignatureLink(signature) {
      let signatureUrl = window.location.origin + "/signature/sign-document/" + signature.id;
      this.$copyText(signatureUrl).then(
        () => {
          this.onCopy();
        },
        () => {
          this.onError();
        }
      )
    },
    changeEmail() {
      this.$store.dispatch("alert/clear");
      this.$store.dispatch("document/updateSignatureEmail", {email: this.emailToUpdate, documentUuid: this.document.id, signatureUuid: this.signatureToUpdate.id})
      .then(
        () => {
          this.$store.dispatch("document/getDocument", {uuid: this.uuid})
            .then(document => {
              this.document = document;
            })
          this.emailToUpdate = "";
          this.$store.dispatch("alert/success", "El correo electrónico del firmante se ha actualizado con éxito");
        },
        error => {
          this.$store.dispatch("alert/error", error)
        }
      )
    },
    addSignature() {
      this.$store.dispatch("alert/clear", {});
      if (!this.name || !this.email) {
        this.$store.dispatch("alert/error", "Ingrese el nombre y correo electrónico del firmante para continuar");
        return;
      }
      this.signatures.push({
        name: this.name,
        email: this.email,
        rfc: this.rfc
      });
      this.name = "";
      this.email = "";
      this.rfc = "";
      this.$store.dispatch("alert/success", "Firmante añadido correctamente");
    },
    updateDocument() {
      if (!this.signatures.length) {
        this.$store.dispatch("alert/error", "Ingrese por lo menos un firmante para continuar");
        return;
      }
      this.$store.dispatch("document/updateDocument", {
        document: {
          uuid: this.uuid,
          signatures: this.signatures,
          tries: this.document.attributes.tries,
          remember_at: this.document.attributes.remember_at,
          remember_every: this.document.attributes.remember_every
        }
      })
      .then(() => {
        this.uuid = null;
        this.closePopup();
      })
    },
    resetSignatureFlowTries() {
      this.$store.dispatch("document/resetSignatureFlow", { signatureId: this.signatureToUpdate.id, signatureFlowId: this.getSignatureFlow.attributes.signature_flow_id }).then(
        result => {
          console.log(result)
          if (result.errors) {
            this.$vs.notify({
              title: 'Error',
              text: result.errors[0].detail,
              color: 'danger',
              position: 'top-center',
            })
          }
          this.emailUpdatePrompt = false
          this.closePopup();
        }
      );
    },
    onCopy() {
      this.$vs.notify({
        title: 'Éxito',
        text: 'El texto se ha copiado en el portapapeles',
        color: 'success',
        position: 'top-center',
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Falló',
        text: 'Falló la copia de texto',
        color: 'danger',
        position: 'top-center',
      })
    },
  }
}
</script>

<style scoped>
.vs-card--content{
  margin-bottom: 0px!important;
}



</style>
